import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MatSnackBarConfig,
  MatSnackBarModule,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

export const optionSnackbar: MatSnackBarConfig = {
  horizontalPosition: 'center',
  verticalPosition: 'bottom',
  duration: 500000, // in ms
};

@Component({
  selector: 'app-snackbar-custom',
  templateUrl: './snackbar-custom.component.html',
  styleUrls: ['./snackbar-custom.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatSnackBarModule, MatIconModule],
})
export class SnackbarCustomComponent {
  snackBarRef = inject(MatSnackBarRef);
}
